import { IAPICanOpenInvoiceBillItem } from '../api-modules';
import { BillOrderMode } from './balance';

export interface IInvoiceTypeFormData {
  email: string;
  show_buyer_seller?: InvoiceBuyerSeller[];
  remark?: string;
}

export interface IInvoiceTypeData {
  email: string;
  show_buyer: InvoiceShow;
  show_seller: InvoiceShow;
  remark: string;
}

export interface IInvoiceBodyData {
  name: string;
  type: string;
  unit: string;
  number: number;
  amount: number;
  taxRate: string;
  tax: number;
}

export enum InvoiceBuyerSeller {
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum InvoiceShow {
  Show = 1,
  Hide = 2,
}

export interface IBillAsBillItem extends IAPICanOpenInvoiceBillItem {
  key: string;
}

export interface IBillAsBillOrMonthItem {
  key?: string;
  amount: string;
  alreadyOpen?: string;
  consume_id?: string;
  balance?: string;
  consume_creator?: string;
  consume_type?: BillOrderMode;
  create_time?: string;
  game_id?: number;
  service_id?: number;
  studio_id?: number;
  tax_rate?: string;
  update_time?: string;
  ['invoice_order.amount']?: string;
  year?: string;
  month?: string;
  bills?: IAPICanOpenInvoiceBillItem[];
}
